import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    body: {
        textAlign: 'center',
        paddingTop: 25,
        paddingBottom: 15
    },
    icon: {
        color: '#a94442',
        fontSize: 64
    },
    heading: {
        color: '#a94442',
        fontSize: 30,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        marginTop: 20,
        marginBottom: 20
    },
    rule: {
        borderTop: '1px solid #a94442',
        marginTop: 0,
        marginBottom: 20
    },
    message: {
        fontSize: 16
    }
};
